/* eslint-disable */
// This file is automatically generated, do not modify

/*
 * jmlib-js - Portable JuggleMaster Library (JavaScript Version)
 * Version 2.0
 * (C) Per Johan Groland 2006-2016
 *
 * Based on JMLib 2.0, (C) Per Johan Groland and Gary Briggs
 *
 * Based on JuggleMaster Version 1.60
 * Copyright (c) 1995-1996 Ken Matsuoka
 *
 * You may redistribute and/or modify JMLib_js under the terms of the
 * Modified BSD License as published in various places online or in the
 * COPYING.jmlib file in the package you downloaded.
 *
 * This program is distributed in the hope that it will be useful, but
 * WITHOUT  ANY  WARRANTY;  without   even  the  implied  warranty  of
 * MERCHANTABILITY or  FITNESS FOR A PARTICULAR PURPOSE.   See the
 * Modified BSD License for more details.
 */
import {patternArray, groups} from "./patternData";

class Pattern {
    constructor(name, site, style, heightRatio, dwellRatio, source) {
        this.name = name;
        this.site = site;
        this.style = style;
		this.heightRatio = heightRatio;
		this.dwellRatio = dwellRatio;
		this.source = source;
	}
}

const patterns = new Map();
const patternIdx = [];
for (const [name, ...rest] of Object.values(patternArray)) {
    patterns.set(name, new Pattern(name, ...rest));
	patternIdx.push(name);
}

export { patterns, patternIdx };